import React, { createContext, useState, useContext, useEffect } from 'react'

const LanguageContext = createContext()

export const LanguageProvider = ({ children }) => {
  // Initialize with either stored preference or browser language or default to English
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('language')
    if (savedLanguage) return savedLanguage

    // Check if browser language preference is Hebrew
    const browserLang = navigator.language || navigator.userLanguage
    if (browserLang.includes('he') || browserLang.includes('iw')) {
      return 'he'
    }

    return 'en' // Default to English
  })

  // Store language preference when it changes
  useEffect(() => {
    localStorage.setItem('language', language)
    // Set direction based on language - RTL for Hebrew, LTR for others
    document.documentElement.dir = language === 'he' ? 'rtl' : 'ltr'
    document.documentElement.lang = language
  }, [language])

  const toggleLanguage = () => {
    setLanguage((prevLang) => (prevLang === 'en' ? 'he' : 'en'))
  }

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  )
}

export const useLanguage = () => useContext(LanguageContext)
